import React, { useEffect, useState } from 'react';
import { Layout, message, ConfigProvider } from 'antd';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { UserProvider, useUser } from './context/UserContext';
import { Preferences } from '@capacitor/preferences';
import Navbar from './components/Navbar';
import AppHeader from './components/Header';
import Login from './components/Login';
import ClienteDashboard from './components/ClienteDashboard';
import TrainerDashboard from './components/TrainerDashboard';
import UserProfile from './components/UserProfile';
import Register from './components/Register';
import TrainerHistory from './components/TrainerHistory';
import Home from './components/Home';
import WorkoutPlansPage from './components/WorkoutPlansPage';
import TrainerRoute from './components/TrainerRoute';
import TrainerWorkoutForm from './components/TrainerWorkoutForm';
import RegisterUser from './components/RegisterUser';
import ResetPassword from './components/ResetPassword';
import ChangePassword from './components/ChangePassword';
import SafeAreaView from './components/SafeAreaView';
import ExerciseList from './components/ExerciseList';
import DailyWorkout from './components/DailyWorkout';
import PersonalTrainersPage from './components/PersonalTrainersPage';
import TrainerDetailsPage from './components/TrainerDetailsPage';
import ClienteRoute from './components/ClienteRoute';
import RichiediSchedaPage from './components/RichiediSchedaPage';
import RegistrationRequestsPage from './components/RegistrationRequestsPage';
import CoursePlanPage from './components/CoursePlanPage';
import ClientListPage from './components/ClientListPage';
import WODDetails from './components/WODDetails';
import LandingPage from './components/LandingPage';
import UpdateGate from './components/UpdateGate';
import ErrorBoundary from './components/ErrorBoundary';
import './App.css';
import './index.css';
import { setUnauthorizedHandler } from './api';
import { temaAntd } from './theme';

// I messaggi comparivano sopra l'intestazione, coprendo il logo.
message.config({ top: 80, duration: 3 });


const AppContent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useUser();
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
  const [loading, setLoading] = useState(true);

  // Quando il server rifiuta la sessione, si rientra al login con un avviso
  // invece di lasciare la pagina vuota.
  useEffect(() => {
    setUnauthorizedHandler(() => {
      setUser(null);
      message.warning('Sessione scaduta, accedi di nuovo.');
      navigate('/login');
    });
  }, [navigate, setUser]);

  useEffect(() => {
    const checkAuth = async () => {
      const token = await Preferences.get({ key: 'token' });
      const userData = await Preferences.get({ key: 'user' });

      if (token.value && userData.value) {
        const user = JSON.parse(userData.value);
        setUser(user);
        if (location.pathname === '/' || location.pathname === '/login') {
          navigate(user.role === 'trainer' ? '/trainer-dashboard' : '/cliente-dashboard');
        }
      } else if (location.pathname !== '/login' && location.pathname !== '/register' && !location.pathname.includes('/reset-password/')  && location.pathname !== '/android') {
        navigate('/login');
      }
      setLoading(false);
    };
    checkAuth();
  }, [location.pathname, navigate, setUser]);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (loading) return <div>Caricamento...</div>;

  return (
    <Layout className="App">
      {location.pathname !== '/login' &&
       location.pathname !== '/register' &&
       location.pathname !== '/' &&
       location.pathname !== '/change-password' &&
       location.pathname !== '/android' &&
       !location.pathname.includes('/reset-password/') &&
       !isDesktop && (
          <AppHeader />
      )}
      <Navbar />
      
      <Layout className="layout-content">
        <div className="content">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/home" element={<Home />} />
            <Route path="/register" element={<Register />} />
            <Route path="/cliente-dashboard" element={<ClienteDashboard />} />
            <Route path="/profile" element={<UserProfile />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/exercise-list" element={<ExerciseList />} />
            <Route path="/daily-workout" element={<DailyWorkout />} />
            <Route path="/personal-trainers" element={<PersonalTrainersPage />} />
            <Route path="/trainer/:id" element={<TrainerDetailsPage />} />
            <Route path="/plan-corsi" element={<CoursePlanPage />} />
            <Route path="/android" element={<LandingPage />} />
            <Route path="/wod-details/:id" element={<WODDetails />} />
            <Route element={<ClienteRoute />}>
              <Route path="/new-scheda" element={<RichiediSchedaPage />} />
            </Route>
            <Route element={<TrainerRoute />}>
              <Route path="/trainer-dashboard" element={<TrainerDashboard />} />
              <Route path="/workout-plans" element={<WorkoutPlansPage />} />
              <Route path="/create-workout" element={<TrainerWorkoutForm />} />
              <Route path="/create-workout/:id" element={<TrainerWorkoutForm />} />
              <Route path="/trainer-history" element={<TrainerHistory />} />
              <Route path="/register-user" element={<RegisterUser />} />
              <Route path="/registrations" element={<RegistrationRequestsPage />} />
              <Route path="/client-list" element={<ClientListPage />} />
            </Route>
          </Routes>
        </div>
      </Layout>
    </Layout>
  );
};

const App = () => {
  return (
    <ConfigProvider theme={temaAntd}>
      <ErrorBoundary>
        <SafeAreaView>
          <UpdateGate>
            <Router>
              <UserProvider>
                <AppContent />
              </UserProvider>
            </Router>
          </UpdateGate>
        </SafeAreaView>
      </ErrorBoundary>
    </ConfigProvider>
  );
};

export default App;
